import { Form, Formik } from "formik";
import Button from "../UI/Button";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import Callout from "../UI/Callout";
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
import {
  MAINTENANCE_LOG_INITIAL_VALUE,
  maintenanceLogValidationSchema,
} from "../../models/maintenance_log";
import TextInput from "../UI/TextInput";
import TextArea from "../UI/TextArea";
import { handleAPIError } from "../../utils/index.jsx";
import { useState } from "react";

export default function MaintenanceLogForm({
  onSubmit,
  maintenanceLog,
  onDelete,
}) {
  const initialValues = toInitialValuesFromSchema(
    maintenanceLogValidationSchema,
    maintenanceLog,
    MAINTENANCE_LOG_INITIAL_VALUE,
  );
  const [error, setError] = useState("");

  async function submitHandler(values, { resetForm }) {
    setError("");
    const sanitizedValues = sanitizeValues(values);
    try {
      await onSubmit(sanitizedValues);
      resetForm();
    } catch (error) {
      setError(handleAPIError(error));
    }
  }
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={maintenanceLogValidationSchema}
      onSubmit={submitHandler}
    >
      {() => (
        <>
          <p className={"cardTitle text-center marginB20"}>
            {maintenanceLog ? "Modifier l'article" : "Ajouter un article"}
          </p>

          <Form>
            <TextInput name={"titre"} label={"Titre"} mandatory />
            <TextArea name={"description"} label={"Description"} />
            <TextInput
              type={"date"}
              name={"date_intervention"}
              label={"Date d'intervention"}
            />
            <TextInput
              type={"number"}
              name={"cout"}
              step={"0.01"}
              label={"Coût (€)"}
            />
            <div className={"text-right"}>
              {maintenanceLog && (
                <Button
                  type={"button"}
                  variant="secondary"
                  className={"marginR10"}
                  onClick={async () => {
                    if (
                      window.confirm(
                        "Voulez-vous vraiment supprimer cet article ?",
                      )
                    ) {
                      try {
                        await onDelete();
                      } catch (error) {
                        console.error(error);
                      }
                    }
                  }}
                >
                  Supprimer
                </Button>
              )}
              <FormikSubmitButton>Valider</FormikSubmitButton>
            </div>
            <Callout variant="danger">{error}</Callout>
          </Form>
        </>
      )}
    </Formik>
  );
}
